import { render, staticRenderFns } from "./dropdown_contents_create_view.vue?vue&type=template&id=5684ffd2"
import script from "./dropdown_contents_create_view.vue?vue&type=script&lang=js"
export * from "./dropdown_contents_create_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports